var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetafechar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2564 0L14.9533 5.30303V1.07239H12.5964V9.32155H20.8456V6.96465H16.6149L21.918 1.66162L20.2564 0ZM1.99036 11.6785V14.0354H6.221L0.917969 19.3384L2.57958 21L7.88262 15.697V19.9276H10.2395V11.6785H1.99036Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetafechar);
export default __webpack_public_path__ + "static/media/setafechar.b90172767e7dfcbce929a1b7ff75837d.svg";
export { ForwardRef as ReactComponent };